import { render, staticRenderFns } from "./AppVersionUpdates.vue?vue&type=template&id=053d09cf"
import script from "./AppVersionUpdates.vue?vue&type=script&lang=ts"
export * from "./AppVersionUpdates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports